/**
 * Converts a comma and/or newline separated string into an array of trimmed, non-empty values.
 *
 * Consecutive delimiters or extra whitespace are ignored; empty entries are removed.
 * @example
 * storyblokProductSearchFiltersGetValuesFromString('red, blue\n green,,');
 * * // Returns: ['red', 'blue', 'green']
 */
export const storyblokProductSearchFiltersGetValuesFromString = (
  stringValue?: string,
): string[] =>
  (stringValue ?? '')
    .split(/[,\n]/u)
    .map((value) => value.trim())
    .filter((value) => value !== '')
